import { MyAccountCharts } from './MyAccountCharts';
import { SubAccountsCharts } from './SubAccountsCharts';
import { TFunction } from 'i18next';
import { useLazyGetSimUsagesQuery } from '@src/services/dashboard/simUsages/simUsagesApiSlice';
import { useLazyGetInUseSimsQuery } from '@src/services/dashboard/inUseSims/inUseSimsApiSlice';
import { useEffect, useMemo } from 'react';
import { DashboardParams } from '@src/services/dashboard/dashboardTypes';
import { useLazyGetInUseSimsTotalQuery } from '@src/services/dashboard/inUseSimsTotal/inUseSimsTotalApiSlice';

type AccountType = 'myAccount' | 'subAccounts';

type ChartsProps = {
    t: TFunction;
    reportType: AccountType;
    filter?: DashboardParams;
};
export const Charts = ({ t, reportType, filter }: ChartsProps) => {
    const [getSimUsages, { data: dataSimUsage }] = useLazyGetSimUsagesQuery();

    const [getInUseSims, { data: dataInUseSims }] = useLazyGetInUseSimsQuery();

    const [getInUseSimsTotal, { data: dataInUseSimsTotal }] =
        useLazyGetInUseSimsTotalQuery();

    const filterKey = useMemo(() => JSON.stringify(filter || {}), [filter]);

    useEffect(() => {
        getSimUsages(filter || {});
        getInUseSims(filter || {});
        getInUseSimsTotal(filter || {});
    }, [filterKey, getSimUsages, getInUseSims, getInUseSimsTotal]);

    if (reportType === 'myAccount') {
        return (
            <div className="w-full">
                <MyAccountCharts
                    dataSimUsage={dataSimUsage?.data ?? []}
                    dataInUseSims={dataInUseSims?.data ?? []}
                />
            </div>
        );
    }
    return (
        <div className="w-full">
            <SubAccountsCharts
                dataSimUsage={dataSimUsage?.data ?? []}
                dataInUseSims={dataInUseSims?.data ?? []}
                dataInUseSimsTotal={dataInUseSimsTotal?.data ?? []}
            />
        </div>
    );
};
